export default {
    default: {
        fetchModelsPeriod: 60000
    },
    listModels: {
        user: {
            url: 'user/',
        },
        site: {
            url: 'site/',
            filter: {
                ordering: '-creation_date',
                archived: false
            }
        },
        area: {
            url: 'area/',
            fetch: false,
            filter: {
                archived: false
            }
        },
        equipment: {
            url: 'equipment/',
            fetch: false,
            filter: {
                archived: false
            }
        },
        simulationUsages: {
            url: 'simulation-usage/',
        },
        simulationMeasureImportRequests: {
            url: 'simulation-measure-import-request/',
            fetch: false
        },
        simulations: {
            url: 'simulation/',
            fetch: false
        },
        simulationAssets: {
            url: 'simulation-asset/',
        },
        siteSimulationResults: {
            url: 'site-simulation-result/',
            fetch: false
        },
        areaSimulationResults: {
            url: 'area-simulation-result/',
            fetch: false
        },
        equipmentSimulationResults: {
            url: 'equipment-simulation-result/',
            fetch: false
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/meta.js